import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import CircularProgress from "@material-ui/core/CircularProgress";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Divider from "@material-ui/core/Divider";
import { vsprintf } from "sprintf-js";
import commons from "./../common/commons";

const styles = (theme) => ({
  root: {
    margin: theme.spacing(2),
    marginTop: 35,
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  stepper: {
    padding: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
    fontSize: "13pt",
    fontWeight: 500,
  },
  depositSummary: {
    background: "#fff3cd",
    borderRadius: 8,
    padding: theme.spacing(2),
    margin: theme.spacing(2, 0),
    textAlign: "center",
  },
  fullPaymentNotice: {
    background: "#e3f2fd",
    borderRadius: 8,
    padding: theme.spacing(2),
    margin: theme.spacing(2, 0),
    textAlign: "center",
  },
  formField: {
    margin: theme.spacing(1),
    width: "100%",
    maxWidth: 400,
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2),
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  emptyCart: {
    textAlign: "center",
    padding: theme.spacing(4),
  },
  productCell: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    direction: "rtl",
  },
  productImage: {
    width: 56,
    height: 56,
    objectFit: "contain",
    borderRadius: 4,
    border: "1px solid #eee",
    flexShrink: 0,
  },
  productName: {
    fontSize: "0.9rem",
    lineHeight: 1.3,
  },
  deliverySection: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: "1px solid #eee",
    borderRadius: 8,
    maxWidth: 400,
    width: "100%",
  },
  deliveryTitle: {
    fontSize: "1.1rem",
    fontWeight: 500,
    marginBottom: theme.spacing(1),
  },
  pickupNotice: {
    background: "#e8f5e9",
    borderRadius: 6,
    padding: theme.spacing(1.5),
    marginTop: theme.spacing(1),
    fontSize: "0.9rem",
    lineHeight: 1.5,
  },
  shippingFields: {
    marginTop: theme.spacing(1),
  },
  cartSummaryBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(1, 2),
    background: "#f5f5f5",
    borderRadius: 6,
    margin: theme.spacing(0, 2, 1),
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  cartSummaryItems: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  cartSummaryChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: 16,
    padding: "4px 10px",
    fontSize: "0.85rem",
  },
  cartSummaryChipImg: {
    width: 24,
    height: 24,
    objectFit: "contain",
    borderRadius: 3,
  },
  clearCartButton: {
    fontSize: "0.8rem",
    textTransform: "none",
    color: "#d32f2f",
    borderColor: "#d32f2f",
    minWidth: "auto",
    whiteSpace: "nowrap",
  },
  errorMsg: {
    color: "#d32f2f",
    textAlign: "center",
    padding: theme.spacing(2),
  },
  "@media (min-width: 1024px)": {
    root: {
      width: 900,
      marginLeft: "auto",
      marginRight: "auto",
      marginTop: 90,
    },
  },
});

const hebrewLabels = {
  steps: ["פרטים אישיים", "סיכום ותשלום"],
  pageTitle: "הזמנה מראש עם מקדמה",
  emptyCart: "עגלת ההזמנה המוקדמת ריקה",
  goBack: "חזרה לחנות",
  next: "המשך",
  back: "חזרה",
  submitDeposit: "שלם מקדמה",
  depositLabel: "סכום המקדמה לתשלום",
  remainingLabel: "יתרה לתשלום בהמשך",
  fullTotalLabel: "סה״כ מחיר מלא",
  name: "שם מלא",
  phone: "טלפון",
  email: "אימייל",
  loading: "מעבד...",
  deliveryTitle: "אופן קבלת הצמיגים",
  deliveryQuestion: "כיצד תרצה לקבל את הצמיגים?",
  shipping: "משלוח עד הבית עם שליח",
  pickup: "איסוף עצמי",
  pickupNotice: "איסוף עצמי אפשרי מהמחסן שלנו בכתובת: אליהו איתן 32, ראשון לציון",
  pickupNotice2: "לאחר ההזמנה, נציג מטעמנו יצור קשר לתיאום האיסוף. אין להגיע לאסוף ללא תיאום מראש!",
  shippingAddress: "כתובת",
  shippingCity: "עיר",
  shippingName: "איש קשר למשלוח",
  clearCart: "רוקן עגלה",
  itemsInCart: "פריטים בעגלה",
  product: "מוצר",
  quantity: "כמות",
  price: "מחיר",
  remove: "הסר",
};

class DepositCheckoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mounted: false,
      activeStep: 0,
      personal: {
        name: "",
        phone: "",
        emailaddress: "",
      },
      sip: "shipping",
      shipping: {
        name: "",
        phone: "",
        address: "",
        city: "",
      },
    };
  }

  componentDidMount() {
    this.setState({ mounted: true });
    const { depositReducer } = this.props;
    if (depositReducer.cart.items.length > 0) {
      this.props.depositActions.getDepositPreview(depositReducer.cart);
      this.props.catalogActions.getCartProducts(depositReducer.cart);
    }
  }

  componentDidUpdate(prevProps) {
    const { depositReducer } = this.props;
    const prevDeposit = prevProps.depositReducer;
    // If cart items changed, refresh preview
    if (
      depositReducer.cart.items.length > 0 &&
      JSON.stringify(depositReducer.cart.items) !==
        JSON.stringify(prevDeposit.cart.items)
    ) {
      this.props.depositActions.getDepositPreview(depositReducer.cart);
    }
  }

  handlePersonalChange = (field) => (event) => {
    this.setState({
      personal: {
        ...this.state.personal,
        [field]: event.target.value,
      },
    });
  };

  handleSipChange = (event) => {
    this.setState({ sip: event.target.value });
  };

  handleShippingChange = (field) => (event) => {
    this.setState({
      shipping: {
        ...this.state.shipping,
        [field]: event.target.value,
      },
    });
  };

  handleNext = () => {
    this.setState({ activeStep: this.state.activeStep + 1 });
  };

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  };

  handleClearCart = () => {
    this.props.depositActions.clearDepositCart();
  };

  handleRemoveItem = (ean) => {
    this.props.depositActions.removeFromDepositCart(ean);
  };

  handleUpdateQuantity = (ean, newQty) => {
    this.props.depositActions.updateDepositQuantity(ean, parseInt(newQty) || 1);
  };

  handleSubmitDeposit = () => {
    const { depositReducer } = this.props;
    const { personal, sip, shipping } = this.state;

    const checkoutObject = {
      personal,
      selectedPaymentMethod: "creditcard",
      payment: { payments: 1 },
      sip,
    };

    if (sip === "shipping") {
      checkoutObject.shipping = {
        name: shipping.name || personal.name,
        phone: shipping.phone || personal.phone,
        address: shipping.address,
        city: shipping.city,
      };
    }

    this.props.depositActions.submitDepositOrder(depositReducer.cart, checkoutObject);
  };

  isPersonalValid = () => {
    const { name, phone, emailaddress } = this.state.personal;
    const personalValid = name.length > 1 && phone.length >= 9 && emailaddress.includes("@");

    if (this.state.sip === "shipping") {
      const { address, city } = this.state.shipping;
      return personalValid && address.length > 1 && city.length > 1;
    }

    return personalValid;
  };

  renderCartSummaryBar() {
    const { classes, depositReducer, catalog } = this.props;
    const items = depositReducer.cart.items;
    const cartProducts = catalog.cartProducts || [];

    return (
      <div className={classes.cartSummaryBar}>
        <div className={classes.cartSummaryItems}>
          <Typography variant="body2" style={{ fontWeight: 500 }}>
            {hebrewLabels.itemsInCart}:
          </Typography>
          {items.map((item) => {
            const product = cartProducts.find((p) => p.ean === item.ean);
            const imageUrl = product
              ? commons.getProductPrimaryImage(
                  product.cdn,
                  product.ean,
                  product.source === "georgia"
                ).url
              : null;
            const label = product
              ? `${product.brand} ${product.displayName}`
              : item.ean;

            return (
              <span key={item.ean} className={classes.cartSummaryChip}>
                {imageUrl && (
                  <img src={imageUrl} alt={label} className={classes.cartSummaryChipImg} />
                )}
                {label} &times;{item.quantity}
                <IconButton
                  size="small"
                  onClick={() => this.handleRemoveItem(item.ean)}
                  style={{ padding: 2, marginRight: -4 }}
                >
                  <DeleteIcon style={{ fontSize: 16 }} />
                </IconButton>
              </span>
            );
          })}
        </div>
        <Button
          variant="outlined"
          size="small"
          className={classes.clearCartButton}
          onClick={this.handleClearCart}
        >
          {hebrewLabels.clearCart}
        </Button>
      </div>
    );
  }

  renderCartItems() {
    const { classes, depositReducer, catalog } = this.props;
    const items = depositReducer.cart.items;
    const cartProducts = catalog.cartProducts || [];

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="right">{hebrewLabels.product}</TableCell>
            <TableCell align="center">{hebrewLabels.quantity}</TableCell>
            <TableCell align="center">{hebrewLabels.price}</TableCell>
            <TableCell align="center">{hebrewLabels.remove}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => {
            const product = cartProducts.find((p) => p.ean === item.ean);
            const imageUrl = product
              ? commons.getProductPrimaryImage(
                  product.cdn,
                  product.ean,
                  product.source === "georgia"
                ).url
              : null;

            return (
              <TableRow key={item.ean}>
                <TableCell align="right">
                  <div className={classes.productCell}>
                    {imageUrl && (
                      <img
                        src={imageUrl}
                        alt={product ? product.displayName : item.ean}
                        className={classes.productImage}
                      />
                    )}
                    <span className={classes.productName}>
                      {product
                        ? `${product.brand} ${product.displayName} ${product.displaySize}`
                        : item.ean}
                    </span>
                  </div>
                </TableCell>
                <TableCell align="center">
                  <TextField
                    type="number"
                    value={item.quantity}
                    onChange={(e) =>
                      this.handleUpdateQuantity(item.ean, e.target.value)
                    }
                    inputProps={{ min: 1, max: 10, style: { width: 50, textAlign: "center" } }}
                  />
                </TableCell>
                <TableCell align="center">
                  {product
                    ? `${vsprintf("%.2f", [product.price * item.quantity])} ₪`
                    : "-"}
                </TableCell>
                <TableCell align="center">
                  <IconButton onClick={() => this.handleRemoveItem(item.ean)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }

  renderPersonalStep() {
    const { classes } = this.props;
    const { personal, sip, shipping } = this.state;

    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 16 }}>
        <Typography variant="h6" gutterBottom>
          פרטים אישיים
        </Typography>
        <TextField
          className={classes.formField}
          label={hebrewLabels.name}
          value={personal.name}
          onChange={this.handlePersonalChange("name")}
          required
        />
        <TextField
          className={classes.formField}
          label={hebrewLabels.phone}
          value={personal.phone}
          onChange={this.handlePersonalChange("phone")}
          type="tel"
          required
        />
        <TextField
          className={classes.formField}
          label={hebrewLabels.email}
          value={personal.emailaddress}
          onChange={this.handlePersonalChange("emailaddress")}
          type="email"
          required
        />

        <Divider style={{ width: "100%", maxWidth: 400, margin: "16px 0 8px" }} />

        <div className={classes.deliverySection}>
          <Typography className={classes.deliveryTitle}>
            {hebrewLabels.deliveryTitle}
          </Typography>
          <FormControl component="fieldset">
            <FormLabel component="legend">{hebrewLabels.deliveryQuestion}</FormLabel>
            <RadioGroup
              name="sip"
              value={sip}
              onChange={this.handleSipChange}
            >
              <FormControlLabel value="shipping" control={<Radio />} label={hebrewLabels.shipping} />
              <FormControlLabel value="pickup" control={<Radio />} label={hebrewLabels.pickup} />
            </RadioGroup>
          </FormControl>

          {sip === "pickup" && (
            <div className={classes.pickupNotice}>
              <Typography variant="body2">{hebrewLabels.pickupNotice}</Typography>
              <Typography variant="body2" style={{ marginTop: 4, fontWeight: 500 }}>
                {hebrewLabels.pickupNotice2}
              </Typography>
            </div>
          )}

          {sip === "shipping" && (
            <div className={classes.shippingFields}>
              <TextField
                className={classes.formField}
                label={hebrewLabels.shippingName}
                value={shipping.name}
                onChange={this.handleShippingChange("name")}
                placeholder={personal.name || ""}
              />
              <TextField
                className={classes.formField}
                label={hebrewLabels.shippingAddress}
                value={shipping.address}
                onChange={this.handleShippingChange("address")}
                required
              />
              <TextField
                className={classes.formField}
                label={hebrewLabels.shippingCity}
                value={shipping.city}
                onChange={this.handleShippingChange("city")}
                required
              />
            </div>
          )}
        </div>

        <div className={classes.actions}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={this.handleNext}
            disabled={!this.isPersonalValid()}
          >
            {hebrewLabels.next}
          </Button>
        </div>
      </div>
    );
  }

  renderConfirmStep() {
    const { classes, depositReducer } = this.props;
    const { preview, loading, error } = depositReducer;

    return (
      <div style={{ padding: 16 }}>
        <Typography variant="h6" gutterBottom style={{ textAlign: "center" }}>
          סיכום הזמנה
        </Typography>

        {this.renderCartItems()}

        {preview && (
          <div className={classes.depositSummary}>
            <Typography variant="body1">
              <strong>{hebrewLabels.fullTotalLabel}:</strong>{" "}
              {vsprintf("%.2f", [preview.fullTotal])} ₪
            </Typography>
            <Typography variant="h6" style={{ color: "#856404", marginTop: 8 }}>
              <strong>{hebrewLabels.depositLabel}:</strong>{" "}
              {vsprintf("%.2f", [preview.depositAmount])} ₪
            </Typography>
            <Typography variant="body1" style={{ marginTop: 4 }}>
              <strong>{hebrewLabels.remainingLabel}:</strong>{" "}
              {vsprintf("%.2f", [preview.remainingAmount])} ₪
            </Typography>
          </div>
        )}

        {error && (
          <Typography className={classes.errorMsg}>
            שגיאה: {error}
          </Typography>
        )}

        <div className={classes.actions}>
          <Button
            variant="outlined"
            className={classes.button}
            onClick={this.handleBack}
          >
            {hebrewLabels.back}
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={this.handleSubmitDeposit}
            disabled={loading || !preview}
          >
            {loading ? (
              <CircularProgress size={24} />
            ) : (
              hebrewLabels.submitDeposit
            )}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { classes, depositReducer } = this.props;
    const { activeStep, mounted } = this.state;

    // Wait for client mount to avoid SSR hydration mismatch
    // (server has no cookies so cart is always empty during SSR)
    if (!mounted) {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <div style={{ textAlign: "center", padding: 32 }}>
              <CircularProgress size={40} />
            </div>
          </Paper>
        </div>
      );
    }

    // Empty cart
    if (depositReducer.cart.items.length === 0) {
      return (
        <div className={classes.root}>
          <Paper className={classes.paper}>
            <div className={classes.emptyCart}>
              <Typography variant="h6">{hebrewLabels.emptyCart}</Typography>
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={() => (window.location.href = "/")}
                style={{ marginTop: 16 }}
              >
                {hebrewLabels.goBack}
              </Button>
            </div>
          </Paper>
        </div>
      );
    }

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <Typography
            variant="h5"
            style={{ textAlign: "center", padding: 16 }}
          >
            {hebrewLabels.pageTitle}
          </Typography>

          {this.renderCartSummaryBar()}

          <Stepper activeStep={activeStep} alternativeLabel>
            {hebrewLabels.steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          {activeStep === 0 && this.renderPersonalStep()}
          {activeStep === 1 && this.renderConfirmStep()}
        </Paper>
      </div>
    );
  }
}

DepositCheckoutPage.propTypes = {
  classes: PropTypes.object.isRequired,
  depositReducer: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  depositActions: PropTypes.object.isRequired,
  catalogActions: PropTypes.object.isRequired,
};

export default withStyles(styles)(DepositCheckoutPage);
